// Styles for ConsentList go here.
import styled from 'styled-components';

export const StyledConsentsList = styled.div`
  margin: 2rem;

  &.anchor__newTab a::after {
    content: '↗'; /* Unicode arrow pointing to top-right */
    vertical-align: middle;
  }
`;
